export const CANCEL_CONFIGURATION_PROMPT = 'CANCEL_CONFIGURATION_PROMPT';
export const REDUCER_CANCEL_CONFIGURATION_PROMPT = 'REDUCER_CANCEL_CONFIGURATION_PROMPT';

export const cancelConfigurationPrompt = (limboKey: string) => ({
  type: CANCEL_CONFIGURATION_PROMPT,
  data: {
    limboKey
  }
});
